import React from "react";
import { Box, Typography, LinearProgress } from "@mui/material";

/**
 * StepHeader - Progress bar and step indicator at the top of the flow
 *
 * @param {number} currentStep - Current step (1-based)
 * @param {number} totalSteps - Total number of steps
 */
const StepHeader = ({ currentStep = 1, totalSteps = 3 }) => {
  const progress = (currentStep / totalSteps) * 100;

  return (
    <Box sx={{ mb: 3 }}>
      {/* Progress bar */}
      <LinearProgress
        variant="determinate"
        value={progress}
        sx={{
          height: 6,
          borderRadius: 3,
          backgroundColor: "#E9E3FF",
          "& .MuiLinearProgress-bar": {
            borderRadius: 3,
            background: "linear-gradient(90deg, #7C3AED, #6200EE)",
          },
        }}
      />

      {/* Step label */}
      <Typography
        sx={{
          mt: 1,
          fontSize: "0.8rem",
          fontWeight: 600,
          color: "#7C3AED",
          textTransform: "lowercase",
        }}
      >
        step {currentStep}/{totalSteps}
      </Typography>
    </Box>
  );
};

export default StepHeader;
